import { combineReducers } from '@reduxjs/toolkit'
import projectListReducer from './projectListSlice'
import memberListReducer from './memberListSlice'
import reservationListReducer from './reservationListSlice'
import reservationGroupedReducer from './reservationGroupedSlice'
import reservationDetailReducer from './reservationDetailSlice'
import reservationSlotsReducer from './reservationSlotsSlice'
import therapistOnDutyReducer from './therapistOnDutySlice'
import therapistDetailReducer from './therapistDetailSlice'
import therapistScheduleGroupedReducer from './therapistScheduleGroupedSlice'
import shiftListReducer from './shiftListSlice'
import shiftOptionsReducer from './shiftOptionsSlice'
import purchaseOrderListReducer from './purchaseOrderListSlice'
import memberEntitlementsReducer from './memberEntitlementsSlice'

const tuinaStore = combineReducers({
  projectList: projectListReducer,
  memberList: memberListReducer,
  memberEntitlements: memberEntitlementsReducer,
  purchaseOrderList: purchaseOrderListReducer,
  reservationList: reservationListReducer,
  reservationGrouped: reservationGroupedReducer,
  reservationDetail: reservationDetailReducer,
  reservationSlots: reservationSlotsReducer,
  therapistOnDuty: therapistOnDutyReducer,
  therapistDetail: therapistDetailReducer,
  therapistScheduleGrouped: therapistScheduleGroupedReducer,
  shiftList: shiftListReducer,
  shiftOptions: shiftOptionsReducer
})

export default tuinaStore
